import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientInformationConstants } from '../../patientInformation/store/patientInformation.constants'
import { IPcr } from '../../pcr/store/pcr.types'
import { setPatientAllergies } from '../store/patientAllergies.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* getPatientAllergies(pcrDoc: IPcr) {
  const patientAllergies = pcrDoc.patient?.patientAllergies

  if (patientAllergies && Object.keys(patientAllergies).length !== 0) {
    yield put(setPatientAllergies(patientAllergies))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(getPatientAllergies, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in getPatientAllergies.saga.ts: ${e}`))
  }
}

export function* getPatientAllergiesSaga() {
  yield takeLatest([PatientInformationConstants.REFRESH_PATIENT_DATA], performWithMutexHOG, preloadPCR)
}
